export const formula = /^(?:\$\$?|{|}|(\\begin|\\end)\s*{[^}]*})/
